// extracted by mini-css-extract-plugin
export default {"all_types_table":"AllTypesTable_all_types_table__4CICV"};